import zh from 'config/langs/zh_CN';
import en from 'config/langs/en_US';
import tc from 'config/langs/tc';
import Config from 'config/Config';

export default {
  zhCN:zh,
  enUS:en,
  tc:tc,
}[Config.languageEnv];


// WEBPACK FOOTER //
// ./src/config/langs/index.js